import GroupMap from './group/GroupMap.js';
import doc_ready from 'document-ready';

function createAsd() {
    doc_ready(function() {
        try {
            GroupMap.init();
        }
        catch (e) {
            console.log('not supported browser');
            alert('Per vedere la mappa, usa un browser più aggiornato: https://www.firefox.com');
            let el = document.getElementById('groupmap');
            el.style.display = 'none';
        }
    });
}

export default createAsd();
